/**
 * Points Display Block - Editor Integration
 *
 * Registers the block type for the editor and allows it to be inserted into checkout areas.
 */
import { registerBlockType } from "@wordpress/blocks";
import { __ } from "@wordpress/i18n";
import Edit from "./edit";
import metadata from "./block.json";
import { registerAsCheckoutInnerBlock } from '../_shared/constants/wc-checkout';

// ============================================================================
// WooCommerce Checkout Inner Block Registration
// ============================================================================

const BLOCK_NAME = 'leat/points-display';

// Register with WooCommerce Blocks checkout filters
registerAsCheckoutInnerBlock(BLOCK_NAME, 'leat-points-display');

// ============================================================================
// Block Registration
// ============================================================================

// Register the block type for the editor
// @ts-ignore - registerBlockType accepts this format
registerBlockType(metadata.name, {
	title: metadata.title,
	category: metadata.category,
	icon: metadata.icon,
	description: metadata.description,
	parent: metadata.parent,
	supports: metadata.supports,
	attributes: metadata.attributes,
	edit: Edit,
	save: () => null, // Dynamic block - rendered via PHP callback
});
